import { Power, Shield, Database, Clipboard, FileText, Calendar, Dribbble, Map, Trello, Server } from 'react-feather'
import themeConfig from '@configs/themeConfig'

export default [
  {
    id: 'home',
    title: 'Home',
    icon: <img src={themeConfig.app.appLogoImage} alt='home-icon' className='logo-wrapper mr-50' />,
    navLink: '/home'
  }, {
    id: 'play',
    title: 'Play',
    icon: <img src={themeConfig.app.playOnImage} alt='play-icon' className='mr-50' />,
    navLink: '/play'
  },
  {
    id: 'learn',
    title: 'Learn',
    icon: <img src={themeConfig.app.coachOnImage} alt='coach-icon' className='mr-50' />,
    navLink: '/learn'
  },
  {
    id: 'admin',
    title: 'Admin Portal',
    icon: <Shield size={20} />,
    navLink: '/admin',
    children: [
      {
        id: 'booking-management',
        title: 'Booking Mgmt',
        icon: <Calendar />,
        navLink: '/admin/booking-management'
      },
      {
        id: 'coaching-management',
        title: 'Coaching Mgmt',
        icon: <Dribbble />,
        navLink: '/admin/coaching-management'
      },
      {
        id: 'member-management',
        title: 'Member Mgmt',
        icon: <Database />,
        navLink: '/admin/member-management'
      },
      {
        id: 'reports',
        title: 'Reports',
        icon: <FileText />,
        navLink: '/admin/reports'
      },
      {
        id: 'venue-management',
        title: 'Venue Mgmt',
        icon: <Map />,
        navLink: '/admin/venue-management'
      },
      {
        id: 'org-management',
        title: 'Org Mgmt',
        icon: <Trello />,
        navLink: '/admin/org-management'
      },
      {
        id: 'shareplay-management',
        title: 'Shareplay Mgmt',
        icon: <Server />,
        navLink: '/admin/shareplay-management'
      }
    ]
  },
  {
    id: 'coach',
    title: 'Coach Portal',
    icon: <Clipboard size={20} />,
    navLink: '/coach'
  },
  {
    id: 'login',
    title: 'Login',
    icon: <Power size={20} />,
    navLink: '/login'
  },
  {
    id: 'logout',
    title: 'Logout',
    icon: <Power size={20} />,
    navLink: '/logout'
  }
]
